import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

const MAX_WORDS_PER_MESSAGE = 2000;
const WarningMessages = ({
  wordsCount,
  inputWarning,
  pricingMethod,
  warningAction,
  handleNavigation,
  wordLimitExceeded,
}) => {
  const pricingMethodIsPerMessage = pricingMethod === 'perMessage';
  return (
    <>
      {inputWarning && (
        <div className="sticky mt-2 bottom-2 left-1 flex px-2 py-1 bg-nue-blue text-white text-xs font-medium gap-2 rounded w-fit">
          <ExclamationTriangleIcon className="w-4 h-4" />
          <div className="select-none">
            Attention: You've reached the word limit for this request. You can
            start a{' '}
            <span className="underline cursor-pointer" onClick={warningAction}>
              new chat
            </span>{' '}
            or{' '}
            <a
              className="underline"
              href="/user-settings"
              onClick={handleNavigation}
            >
              adjust wordcap limits
            </a>{' '}
            in your settings.
          </div>
        </div>
      )}
      {pricingMethodIsPerMessage &&
        !wordLimitExceeded &&
        wordsCount > MAX_WORDS_PER_MESSAGE * 0.8 && (
          <div className="sticky mt-2 bottom-2 left-1 flex px-2 py-1 bg-gray-100 dark:bg-gray-800 text-xs font-medium gap-2 rounded w-fit">
            <div className="select-none">
              <span
                className={`${
                  wordsCount > MAX_WORDS_PER_MESSAGE * 0.9
                    ? 'text-red-500 font-bold'
                    : 'text-orange-500 font-bold'
                }`}
              >
                {wordsCount}
              </span>
              <span className="text-gray-500">
                /{MAX_WORDS_PER_MESSAGE} words
              </span>
            </div>
          </div>
        )}
      {pricingMethod === 'perMessage' && wordLimitExceeded && (
        <div className="sticky mt-2 bottom-2 left-1 flex px-2 py-1 bg-red-500 text-white text-xs font-medium gap-2 rounded w-fit animate-pulse">
          <ExclamationTriangleIcon className="w-4 h-4" />
          <div className="select-none flex items-center">
            <span className="font-bold mr-1">
              {wordsCount}/{MAX_WORDS_PER_MESSAGE}
            </span>
            words - Please delete some text to continue.
          </div>
        </div>
      )}
    </>
  );
};

export default WarningMessages;
